import { constants } from '@/constants'
export default {
  methods: {
    formatDate (dateString: string, options: Intl.DateTimeFormatOptions = { dateStyle: 'short' }, lang = 'pl-PL') {
      if (dateString !== '' && dateString != null && dateString !== undefined) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat(lang, options).format(date)
      }
    },
    formatDateAndTime (dateString: string, hideSeconds?: boolean) {
      if (dateString) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat('pl-PL', { dateStyle: 'short', timeStyle: hideSeconds ? 'short' : 'medium' }).format(date)
      }
    },
    formatCurrency (currency: number) {
      if (localStorage.getItem('store') && localStorage.getItem('store')?.includes('PL')) {
        return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(currency)
      }
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(currency)
    },
    minusValue (value: number) {
      return value > 0 ? -value : value
    },
    formatISODate (isoDate: string): string {
      // Create a Date object from the ISO string
      const date = new Date(isoDate)

      // Get individual components of the date
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-based
      const year = date.getUTCFullYear()
      const hours = String(date.getUTCHours()).padStart(2, '0')
      const minutes = String(date.getUTCMinutes()).padStart(2, '0')
      const seconds = String(date.getUTCSeconds()).padStart(2, '0')

      // Format the date and time in the desired format
      return `${day}.${month}.${year}T${hours}:${minutes}:${seconds}`
    },
    formatDateUserManagement (isoDate: string): string {
      // Create a Date object from the ISO string
      const date = new Date(isoDate)

      // Get individual components of the date
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-based
      const year = date.getUTCFullYear()
      const hours = String(date.getUTCHours()).padStart(2, '0')
      const minutes = String(date.getUTCMinutes()).padStart(2, '0')
      const seconds = String(date.getUTCSeconds()).padStart(2, '0')

      // Format the date and time in the desired format
      return `${day}/${month}/${year}, ${hours}:${minutes}`
    }

  }
}
